// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\TransactionTotalsResponse

import { hydrateTransactionTotalsPosDetail, type TransactionTotalsPosDetail, type TransactionTotalsPosDetailApiResponse } from './transactionTotalsPosDetail.gen';

export type TransactionTotalsApiResponse = {
	online: number;
	onlineCount: number;
	onlineBooking: number;
	onlineBookingCount: number;
	onlineTotal: number;
	pos: number;
	posCount: number;
	netTotal: number;
	bookingSales: number;
	bookingSalesCount: number;
	totalSales: number;
	totalSalesCount: number;
	giftcardMethod: number;
	giftcardMethodCount: number;
	giftcardPurchases: number;
	giftcardPurchasesCount: number;
	packagePurchases: number;
	packagePurchasesCount: number;
	giftcardExpired: number;
	giftcardExpiredCount: number;
	packageConsumptionCredits: number;
	packageConsumptionCount: number;
	packageExpiredCredits: number;
	packageExpiredCount: number;
	posDetails: TransactionTotalsPosDetailApiResponse[];
};

export type TransactionTotals = {
	online: number;
	onlineCount: number;
	onlineBooking: number;
	onlineBookingCount: number;
	onlineTotal: number;
	pos: number;
	posCount: number;
	netTotal: number;
	bookingSales: number;
	bookingSalesCount: number;
	totalSales: number;
	totalSalesCount: number;
	giftcardMethod: number;
	giftcardMethodCount: number;
	giftcardPurchases: number;
	giftcardPurchasesCount: number;
	packagePurchases: number;
	packagePurchasesCount: number;
	giftcardExpired: number;
	giftcardExpiredCount: number;
	packageConsumptionCredits: number;
	packageConsumptionCount: number;
	packageExpiredCredits: number;
	packageExpiredCount: number;
	posDetails: TransactionTotalsPosDetail[];
};

export function hydrateTransactionTotals(data: TransactionTotalsApiResponse): TransactionTotals {
	return {
		...data,
		posDetails: data.posDetails.map(hydrateTransactionTotalsPosDetail),
	};
}